import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

export default class InvoiceItemModel extends Model {
  @attr() allocatedAmount;
  @belongsTo('invoice', { async: false, inverse: 'invoiceItems' }) invoice;
  @belongsTo('appointment', { async: false, inverse: 'invoiceItems' }) appointment;
  @belongsTo('appointment-client', { async: false, inverse: null }) appointmentClient;
  @hasMany('invoice-item', { async: false, inverse: null }) invoiceItems;
  @attr('number') price;
  @attr('number') remainingAmount;
  @attr('moment') issueDate;
}
